export const PersonData = [
    {
        id: 100,
        company: 'Zentrale',
        name: 'Thomas Benjes',
        street: "Neuenlander Str. 29",
        city: "27356 Rotenburg/ Wümme",
        tel: '',
        mobile: '0171 1664256',
        fax: '',
        email: 'thomas.benjes@t-online.de',
        web: '',
    },
    {
        id: 300,
        company: '',
        name: 'Jürgen Basedow - Clark',
        street: 'Luckauer Ring 35',
        city: ' 31241 Ilsede',
        tel: '05172/961874',
        mobile: '',
        fax: '05172/961874',
        email: 'Basedow.Clark@gmail.com',
        web: '',
    },
    {
        id: 500,
        company: '',
        name: 'Günter Buss',
        street: 'Hauptkanal links 93',
        city: '26871 Papenburg',
        tel: '04961/916847',
        mobile: '',
        fax: '04961/916835',
        email: 'guenter-buss@t-online.de',
        web: '',
    },
    {
        id: 800,
        company: 'Büro für Grünplanung Landschaftsarchitekt ',
        name: 'Klaus Wappler ',
        street: 'Nienburger Straße 18 ',
        city: '27333 Schweringen',
        tel: '04257 / 9840940',
        mobile: '',
        fax: '04257 / 9840998',
        email: 'klaus.wappler@t-online.de',
        web: 'http://www.buerofuergruenplanung.de/',
    }
]